module.exports = __webpack_public_path__ + "img/信息系统集成叁级能力证书.d8b0dd6f.png";